
import { RangerFirearmAssignmentLogTypeInfoBase } from './ranger-firearm-assignment-log.typeinfo.base';


export class RangerFirearmAssignmentLogTypeInfo extends RangerFirearmAssignmentLogTypeInfoBase {
}

export const RANGER_FIREARM_ASSIGNMENT_LOG_TYPE: RangerFirearmAssignmentLogTypeInfo = new RangerFirearmAssignmentLogTypeInfo();



